export const validateSalesPopupForm = (formData) => {
  const errors = {};

  if (!formData.name?.trim()) {
    errors.name = 'Name is required';
  } else if (formData.name.length > 100) {
    errors.name = 'Name cannot exceed 100 characters';
  }

  if (!formData.phone?.trim()) {
    errors.phone = 'Phone is required';
  } else if (!/^\+?[\d\s-]{10,}$/.test(formData.phone)) {
    errors.phone = 'Invalid phone number';
  }

  return errors;
};




